import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

export default class extends Controller {
  static targets = ['overlay', 'moreButton', 'moreText']

  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  connect () {
    this.overlayTargets.forEach((target) => {
      target.classList.add('viewcomponent::site::parts::facility::summary::mobile::visible')
    })
  }

  hide (e) {
    e.target.classList.remove('viewcomponent::site::parts::facility::summary::mobile::visible')
  }

  scrollTo (id) {
    const anchor = document.querySelector(id)
    this.scroll.animateScroll(anchor)
  }

  scrollOrRedirectToAccess (e) {
    const plansSection = document.getElementById('access')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#access')
    }
  }

  scrollOrRedirectToReviews (e) {
    const reviewsSection = document.getElementById('reviews')
    if (reviewsSection) {
      this.scrollTo('#reviews')
    } else {
      window.location.href = e.target.dataset.url
    }
  }

  more () {
    this.moreButtonTarget.style.display = 'none'
    this.moreTextTarget.style.display = 'inline'
  }
}
